import React, { useContext, useState, useRef } from "react";
import VariantBuilderPanelLayersItem from "../variants/VariantBuilderPanelLayersItem.js";
import ElementLayer from "../elements/ElementLayer.js";
import { VariantContextData } from "../variants/VariantBuilderContext.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SectionColumnLayer = (props) => {
  const [contextData, builder] = useContext(VariantContextData);
  const section = props.section;
  const column = props.column;
  const isFlex = section.layout_type === "flex";
  const section_column =
    isFlex && column.section_column_id
      ? Object.values(contextData.objects.variant.section_columns || {}).find(
          (sc) => sc.id == column.section_column_id
        )
      : null;
  const sectionColumnStructure =
    (section_column && section_column.options) || {};

  let column_elements = Object.values(
    contextData.objects.variant.elements
  ).filter(
    (e) =>
      e.section_id == section.id &&
      e.toBeDeleted !== true &&
      (isFlex
        ? e.section_column_id == column.section_column_id
        : e.column == column.position)
  );
  let sorted_elements = column_elements.sort(function (a, b) {
    return a.position - b.position;
  });

  const hiddenForDevice = isFlex
    ? sectionColumnStructure[`hide-${contextData.device}`] == "true"
    : section.options["structure"][
        `${column.name}-column-hide-${
          contextData.device == "mobile" ? "mobile" : "desktop"
        }`
      ] == "true";

  const canvasSelector = isFlex
    ? `.cf-flex-column[data-section-column-id='${column.section_column_id}']`
    : `.cf-column[data-section-id='${section.id}'][data-column-position='${column.name}']`;

  const device = contextData.device;
  const canToggleForDevice =
    device == "desktop" ||
    section.options["structure"]["mobile-responsive"] !== "false";

  const toggleForDevice = canToggleForDevice
    ? () => {
        if (isFlex && section_column) {
          builder.update([
            {
              object_type: "section_columns",
              object_id: section_column.id,
              setting_name: `[options][hide-${device}]`,
              value: `${
                (sectionColumnStructure[`hide-${device}`] == "true") == false
              }`,
            },
          ]);
        } else {
          builder.update([
            {
              object_type: "sections",
              object_id: section.id,
              setting_name: `[options][structure][${column.name}-column-hide-${device}]`,
              value: `${
                (section.options["structure"][
                  `${column.name}-column-hide-${device}`
                ] ==
                  "true") ==
                false
              }`,
            },
          ]);
        }
      }
    : undefined;

  return (
    <VariantBuilderPanelLayersItem
      key={`section-${section.id}-column-${column.name}-layer`}
      object_type={isFlex ? "section_columns" : "sections"}
      object_id={isFlex ? column.section_column_id : section.id}
      object={isFlex ? section_column : section}
      column={column}
      title={`Column ${column.position}`}
      open={props.open || false}
      hidden={hiddenForDevice}
      tab={"Columns"}
      canvasSelector={canvasSelector}
      toggleForDevice={toggleForDevice}
      hideMoveCommands={isFlex}
    >
      <div
        className="w-full layers-container"
        data-object-type="sections"
        data-object-id={section.id}
        data-column={column ? column.position : null}
      >
        {sorted_elements.map((element) => {
          return (
            <ElementLayer
              key={`element-${element.id}-layer`}
              element={element}
            />
          );
        })}
      </div>

      <div className="w-full pl-6 mb-3">
        <button
          onClick={() => {
            dispatchCustomEvent("newObject", {
              object_type: "Elements",
              section_id: section.id,
              section_column_id: isFlex ? column.section_column_id : undefined,
              column: column.position,
            });
          }}
          className="w-full p-2 text-left bg-transparent border-none text-xl text-blue-600 dark:text-blue-200 dark:hover:text-white"
        >
          <FontAwesomeIcon icon="plus-square" className="mr-2" /> Add Element
        </button>
      </div>
    </VariantBuilderPanelLayersItem>
  );
};

export default SectionColumnLayer;
